import { Box, Link, Typography } from "@mui/material";
import { ISSUE_STATUSES, Links } from "../../constants";
import { FeedItemDto } from "../../http";
import { StatusIcon } from "src/components";

interface IProps {
  feedItem: FeedItemDto;
}

const IssueStatusPropertyChange = (props: IProps) => {
  const status = ISSUE_STATUSES.find((x) => x.id === props.feedItem.propertyChange!.value);

  return (
    <Typography variant="caption" sx={{ alignItems: "center" }}>
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link> updated status to
      <Box component="span" sx={{ fontWeight: "bold", ml: "2px" }}>
        <StatusIcon status={status!} sx={{ position: "relative", top: "2px" }} fontSize="small" />
        <span> {status!.name}</span>
      </Box>
    </Typography>
  );
};

export { IssueStatusPropertyChange };
